import { shouldUseBulkCredits } from '../../components/Pricing295UnlimitedExceededPopup';
import { SEARCH_STATUS } from '../../utils/constants';
import { BULK_EMPTY_STATES_TYPES } from './constants';
export const BULK_SEARCH_PLATFORM = 'pluginMultiSearch';
export const calculateScrollDepth = (event, currentScrollDepth) => {
    const pageLength = event.target.scrollHeight - event.target.clientHeight;
    const current = Math.ceil((event.target.scrollTop / pageLength) * 100);
    return {
        isScrollDepth: current > currentScrollDepth && current % 25 === 0,
        current,
    };
};
// SHOW HELPERS
export const buildBulkShowQuery = (requestId, contactsToShow, isBulkOptionWindow = false) => ({
    requestId,
    contacts: contactsToShow,
    platform: BULK_SEARCH_PLATFORM,
    isProspecting: true,
    useBulkCredits: shouldUseBulkCredits(),
    isBulkOptionWindow,
});
export const buildBulkAcquireQuery = (requestId, contactsToAcquire) => ({
    contacts: contactsToAcquire,
    platform: BULK_SEARCH_PLATFORM,
    requestId,
});
export const getContactsToShow = tempContacts => {
    const toShowContacts = tempContacts.filter(contact => contact.canShowContact || (!contact.isRevealed && !contact.isWishlistContact && !contact.isWithoutData));
    return toShowContacts.map(contact => contact.id);
};
export const getContactsToAcquire = contacts => contacts.filter(contact => !contact.isRevealed && !contact.isAcquired);
export const getContactsHashesToAcquire = tempContacts => {
    const toAcquireContacts = tempContacts.filter(contact => !contact.isRevealed && !contact.isAcquired);
    return toAcquireContacts.map(contact => contact.contactHash);
};
export const getEmptyStateType = (user, isPageWithoutContacts, searchStatus) => {
    var _a;
    if (isPageWithoutContacts) {
        if ((_a = user.billing) === null || _a === void 0 ? void 0 : _a.isPaid) {
            return BULK_EMPTY_STATES_TYPES.newPageWithoutContacts;
        }
        return BULK_EMPTY_STATES_TYPES.oldPageWithoutContacts;
    }
    if (searchStatus === SEARCH_STATUS.REJECTED) {
        return BULK_EMPTY_STATES_TYPES.serverError;
    }
    return null;
};
